import { createReducer } from '../../../utilities';

import { scope } from '../../../../actions/app/onSite/players/listWidget';
import {
    REQUEST_FETCH_PLAYERS_QUOTATIONS,
    REQUEST_UPDATE_PLAYER_QUOTATION,
    REQUEST_UPDATE_PLAYER_POSITION,
    REQUEST_UPDATE_PLAYER_POSITION_ULTRA,
    REQUEST_FETCH_PLAYERS,
    SUCCESS_FETCH_PLAYERS_QUOTATIONS,
    SUCCESS_UPDATE_PLAYER_QUOTATION,
    SUCCESS_UPDATE_PLAYER_POSITION,
    SUCCESS_UPDATE_PLAYER_POSITION_ULTRA,
    SUCCESS_FETCH_PLAYERS,
    FAIL_FETCH_PLAYERS_QUOTATIONS,
    FAIL_UPDATE_PLAYER_QUOTATION,
    FAIL_UPDATE_PLAYER_POSITION,
    FAIL_UPDATE_PLAYER_POSITION_ULTRA,
    FAIL_FETCH_PLAYERS,
    REQUEST_FETCH_FULL_PLAYERS,
    SUCCESS_FETCH_FULL_PLAYERS,
    FAIL_FETCH_FULL_PLAYERS,
    REQUEST_UPDATE_PLAYER_ACTIVE,
    SUCCESS_UPDATE_PLAYER_ACTIVE,
    FAIL_UPDATE_PLAYER_ACTIVE,
    REQUEST_UPDATE_PLAYER_PROPERTY,
    SUCCESS_UPDATE_PLAYER_PROPERTY,
    FAIL_UPDATE_PLAYER_PROPERTY,
} from '../../../../actions/entities/player';

const initialPlayersListWidgetState = {
    ids: null,
    info: {
        isFetching: false,
        lastAction: null,
        lastPayload: {},
        needRefresh: true,
        updatedAt: null,
        success: false,
        error: false
    }
};

function request(state, action) {
    return {
        ...state,
        info: {
            isFetching: true,
            lastAction: action.type,
            lastPayload: action.payload,
            needRefresh: false,
            updatedAt: null,
            success: false,
            error: false
        }
    };
}

function success(state, action) {
    const { ids, payload, receivedAt, success } = action;

    return {
        ...state,
        ids: ids || state.ids,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            updatedAt: receivedAt,
            success,
            error: false
        }
    };
}

function fail(state, action) {
    const { error, payload, type } = action;
    return {
        ...state,
        ids: type === FAIL_FETCH_PLAYERS_QUOTATIONS ? null : state.ids,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            success: false,
            error
        }
    };
}

export default createReducer(initialPlayersListWidgetState, {
    [REQUEST_FETCH_PLAYERS_QUOTATIONS]: request,
    [REQUEST_UPDATE_PLAYER_QUOTATION]: request,
    [REQUEST_UPDATE_PLAYER_POSITION]: request,
    [REQUEST_UPDATE_PLAYER_POSITION_ULTRA]: request,
    [REQUEST_UPDATE_PLAYER_ACTIVE]: request,
    [REQUEST_FETCH_PLAYERS]: request,
    [REQUEST_FETCH_FULL_PLAYERS]: request,
    [REQUEST_UPDATE_PLAYER_PROPERTY]: request,

    [SUCCESS_FETCH_PLAYERS_QUOTATIONS]: success,
    [SUCCESS_UPDATE_PLAYER_QUOTATION]: success,
    [SUCCESS_UPDATE_PLAYER_POSITION]: success,
    [SUCCESS_UPDATE_PLAYER_ACTIVE]: success,
    [SUCCESS_UPDATE_PLAYER_POSITION_ULTRA]: success,
    [SUCCESS_FETCH_PLAYERS]: success,
    [SUCCESS_FETCH_FULL_PLAYERS]: success,
    [SUCCESS_UPDATE_PLAYER_PROPERTY]: success,

    [FAIL_FETCH_PLAYERS_QUOTATIONS]: fail,
    [FAIL_UPDATE_PLAYER_QUOTATION]: fail,
    [FAIL_UPDATE_PLAYER_POSITION]: fail,
    [FAIL_UPDATE_PLAYER_ACTIVE]: fail,
    [FAIL_UPDATE_PLAYER_POSITION_ULTRA]: fail,
    [FAIL_FETCH_PLAYERS]: fail,
    [FAIL_FETCH_FULL_PLAYERS]: fail,
    [FAIL_UPDATE_PLAYER_PROPERTY]: fail,
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/onSite/players/listWidget.js